import { Trans } from '@lingui/react/macro';
import { Box, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function MessageWrapper(props) {
    const { children } = props;
    return (<Box flexDirection="column" gap="md" p="lg" borderRadius="md" bg="background.100">
      <Box alignItems="center" gap="md">
        <Falcon icon="circle-info"/>
        <Typography $fontSize="small" $fontWeight="medium" $appearance="300" $lineHeight="neutralized">
          <Trans comment="Workflow check is outdated - Title">Document changed since last rule check</Trans>
        </Typography>
      </Box>
      {children}
    </Box>);
}
